<template>
  <div class="issue-item">
    <div class="issue-text">{{issue.value}}<span class="issue-type" v-if="isIndex" :class="{'blue-text': issue.type == 'FEATURE_REC'}">{{issue.typeName}}</span></div>
    <a class="n-blue-btn plain" v-if="!issue.component && isShowNextBtn" :href="issue.btnLink" @click="clickLog(issue.key)">{{issue.btnLabel}}</a>
    <component v-if="issue.component" :is="issue.component" :btn-text="issue.btnLabel" slot-type="button" :dayBudget="+issue.helpData"></component>
  </div>
</template>
<script>
  import SmartCreativeNext from './SmartCreativeNext.vue';
  import FlowPriorityNext from './FlowPriorityNext.vue';
  import EditBudget from 'src/pages/index/components/EditBudget.vue';
  import {LOG_BTN_NAME} from '../utils/const.js';
  export default {
    name: 'issue-item',
    props: {
      isIndex: Boolean,
      issue: {
        type: Object,
        default: () => ({})
      },
      hasCharge: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        userType: 1
      };
    },
    computed: {
      isShowNextBtn() {
        return this.issue.key != 'ACCOUNT_BUDGET_WEEK_SHORT' ? true : this.hasCharge;
      }
    },
    components: {
      SmartCreativeNext,
      FlowPriorityNext,
      EditBudget
    },
    created() {
      const userInfo = (window.GLOBAL || {}).userInfo || {};
      this.userType = userInfo.accountType || 1;
      this.exposeLog();
    },
    methods: {
      clickLog(key) {
        this.$log('click', {
          pageLevel1: this.isIndex ? 'account_homepage' : 'advertising_suggestion',
          pageLevel2: this.isIndex ? 'delivery_suggestion' : 'account_overview',
          pageLevel3: this.isIndex ? 'delivery_suggestion' : 'account_overview',
          element_name: LOG_BTN_NAME[key]
        });
      },
      exposeLog() {
        this.$log('expose', {
          pageLevel1: this.isIndex ? 'account_homepage' : 'advertising_suggestion',
          pageLevel2: this.isIndex ? 'delivery_suggestion' : 'account_overview',
          pageLevel3: this.isIndex ? 'delivery_suggestion' : 'account_overview',
          element_name: LOG_BTN_NAME[this.issue.key]
        });
      }
    }
  }
</script>
<style lang="scss">
  .issue-item {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    align-items: center;
    .issue-text {
      margin-right: 10px;
      font-size: 16px;
      line-height: 22px;
      color: #000000E5;
      font-weight: 500;
      .issue-type {
        display: inline-block;
        width: 68px;
        height: 26px;
        margin-left: 8px;
        line-height: 26px;
        text-align: center;
        background: #FEF9E3;
        color: #EAB836;
        font-size: 14px;
        font-weight: 500;
        &.blue-text {
          background: #ECF4FE;
          color: #3258DD;
        }
      }
    }
    .n-blue-btn {
      flex-shrink: 0;
    }
  }
</style>